module.exports = __webpack_public_path__ + "img/title.70e9bfd9.png";